import { IModelEntity } from '@pit/core';

export interface IDtoAddress extends IModelEntity {

    city?: string;
    houseNumber?: string;
    latitude?: number;
    longitude?: number;
    street?: string;
    zipCode?: string;

    fullAddress?: string;
    fullCity?: string;
    fullStreet?: string;

}
